import type { OperacaoDiaAlertaNivel, OperacaoDiaEtapa } from "../../../services/painelService";
import type { PainelCardUrgencia } from "../../Painel/utils/painelCardUrgencia";
import { PAINEL_URGENCIA_SHELL_CLASS } from "../../Painel/utils/painelCardUrgencia";

export function sequenciaAlertaToUrgencia(
  alerta: OperacaoDiaAlertaNivel,
  etapa: OperacaoDiaEtapa
): PainelCardUrgencia {
  if (etapa === "finalizado" || etapa === "cancelado") return "normal";
  if (alerta === "critico") return "critico";
  if (alerta === "alerta" || alerta === "atencao") return "alerta";
  return "normal";
}

export function sequenciaShellClass(
  alerta: OperacaoDiaAlertaNivel,
  etapa: OperacaoDiaEtapa,
  isPrioritario: boolean
): string {
  if (isPrioritario) {
    return "overflow-hidden rounded-xl border border-red-300 bg-red-50 shadow-sm";
  }
  if (etapa === "finalizado") {
    return "overflow-hidden rounded-xl border border-emerald-200/80 bg-emerald-50/40 shadow-sm";
  }
  if (etapa === "cancelado") {
    return "overflow-hidden rounded-xl border border-neutral-300 bg-neutral-50 shadow-sm";
  }
  if (alerta === "atencao") {
    return "overflow-hidden rounded-xl border border-amber-300 bg-amber-50 shadow-sm";
  }
  const urgencia = sequenciaAlertaToUrgencia(alerta, etapa);
  return PAINEL_URGENCIA_SHELL_CLASS[urgencia];
}
